export const API_URL = process.env.API_URL || 'http://localhost:3006';

// HOTJAR configuration
export const HJID = process.env.HJID && Number(process.env.HJID);
export const HJSV = process.env.HJSV && Number(process.env.HJSV);

export const AUTHY_DISABLED = ['1', 'yes', 'true'].includes(
  process.env.AUTHY_DISABLED || 'false'
);

export const BACKEND_API_HOST =
  process.env.BACKEND_API_HOST || 'http://localhost:3000';

export const C2C_WIDGET_BASE_URL = process.env.REACT_APP_C2C_WIDGET_BASE_URL;
export const BIGEDIRECT_WIDGET_BASE_URL =
  process.env.REACT_APP_BIGEDIRECT_WIDGET_BASE_URL || 'https://test.bige.app';

export const GOOGLE_ANALYTICS_TAG_ID =
  process.env.REACT_APP_GOOGLE_ANALYTICS_TAG_ID ?? null;

export const TENANT = process.env.TENANT as string;
